/* ZeroFat — كويز الهدف (vanilla, no deps) */
(function () {
  'use strict';

  var root = document.querySelector('[data-zq]');
  if (!root) return;

  /* ================= ثوابت الحسبة ================= */

  /* قفل صلب إلزامي: السعرات النهائية عمرها ما تقل عن الحدود دي مهما كانت المدخلات.
     ١٢٠٠ سعرة للستات و١٥٠٠ للرجالة — حد أدنى للسلامة، مش رقم قابل للتعديل من الإعدادات. */
  var CALORIE_FLOOR = { male: 1500, female: 1200 };

  var ACTIVITY = { s1: 1.2, s2: 1.375, s3: 1.55, s4: 1.725, s5: 1.9 };
  var GOAL_ADJ = { cut: 0.80, shred: 0.85, bulk: 1.12, health: 1.00 };
  var PROTEIN_PER_KG = { cut: 2.0, shred: 2.0, bulk: 1.8, health: 1.4 };
  var WATER_ML_PER_KG = 35;

  var AGE_OK_MIN = 18, AGE_OK_MAX = 65;
  var AGE_MIN = 10, AGE_MAX = 99;
  var H_MIN = 120, H_MAX = 220;
  var W_MIN = 35, W_MAX = 250;

  var KEY = 'zf_quiz_v1';
  var TOTAL = 6;

  var L = {
    goal: { cut: 'تخسيس', shred: 'تنشيف', bulk: 'ضخامة', health: 'صحة وطاقة' },
    sex: { male: 'ذكر', female: 'أنثى' },
    act: { s1: 'مكتبي', s2: 'خفيف', s3: 'متوسط', s4: 'عالي', s5: 'رياضي محترف' },
    place: { gym: 'جيم', home: 'بيت', none: 'لسه مبدأتش' },
    hurdle: {
      appetite: 'الشهية', time: 'الوقت',
      slow: 'النتيجة بطيئة', food: 'مش عارف آكل إيه'
    }
  };

  var HURDLE_TIP = {
    appetite: 'قولت إن الشهية أكبر حاجة بتوقفك — عشان كده رقم البروتين اللي فوق ده هو أهم حاجة تركز عليها، لأنه بيشبعك أطول ويقلل الأكل العشوائي.',
    time: 'قولت إن الوقت هو اللي بيوقفك — الخطة دي مبنية على أرقام بسيطة تقدر تحققها من وجبات سريعة التحضير من غير ما تقعد تحسب كتير.',
    slow: 'قولت إن النتيجة البطيئة بتوقفك — الأرقام دي واقعية ومش مبالغ فيها، والالتزام عليها ٨–١٢ أسبوع هو اللي بيفرق فعلًا.',
    food: 'قولت إنك مش عارف تاكل إيه — خد السعرات والبروتين اللي فوق ده كخط أساسي بس، والباقي تفاصيل تظبطها مع الوقت.'
  };

  /* ================= أدوات ================= */

  function q(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* أرقام عربية-هندية للنصوص الظاهرة */
  function ar(v) {
    return String(v).replace(/[0-9]/g, function (d) { return '٠١٢٣٤٥٦٧٨٩'.charAt(+d); }).replace(/\./g, '٫');
  }

  function emit(detail) {
    document.dispatchEvent(new CustomEvent('zf:quiz', { detail: detail }));
  }

  /* ================= الحالة ================= */

  var st = { step: 1, goal: '', sex: '', age: '', health: false, height: '', weight: '', act: '', place: '', freq: '', hurdle: '', done: false };

  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) { /* الوضع الخاص */ }
  }
  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return;
      var o = JSON.parse(raw);
      if (o && typeof o === 'object') {
        for (var k in st) { if (Object.prototype.hasOwnProperty.call(o, k)) st[k] = o[k]; }
      }
    } catch (e) { /* بيانات تالفة — نتجاهلها */ }
  }
  function reset() {
    st = { step: 1, goal: '', sex: '', age: '', health: false, height: '', weight: '', act: '', place: '', freq: '', hurdle: '', done: false };
    try { localStorage.removeItem(KEY); } catch (e) { /* تجاهل */ }
  }

  /* ================= عناصر ================= */

  var body = q('[data-zq-body]');
  var form = q('[data-zq-form]');
  var steps = qa('[data-step]');
  var fill = q('[data-zq-fill]');
  var track = q('[data-zq-track]');
  var count = q('[data-zq-count]');
  var live = q('[data-zq-live]');
  var errBox = q('[data-zq-err]');
  var backBtn = q('[data-zq-back]');
  var res = q('[data-zq-res]');
  var blocked = q('[data-zq-blocked]');
  var picks = q('[data-zq-picks]');
  var addBtn = q('[data-zq-add]');
  var addErr = q('[data-zq-adderr]');
  var addLabel = addBtn ? addBtn.getAttribute('data-label') : '';

  /* ================= التنقل ================= */

  function stepEl(n) {
    for (var i = 0; i < steps.length; i++) {
      if (+steps[i].getAttribute('data-step') === n) return steps[i];
    }
    return null;
  }

  function showStep(n, focus) {
    st.step = n;
    steps.forEach(function (el) { el.hidden = +el.getAttribute('data-step') !== n; });
    if (form) form.hidden = false;
    if (res) res.hidden = true;
    if (blocked) blocked.hidden = true;
    if (backBtn) backBtn.hidden = n === 1;
    if (fill) fill.style.width = (n / TOTAL * 100) + '%';
    if (track) track.setAttribute('aria-valuenow', String(n));
    if (count) count.textContent = ar(n) + ' / ' + ar(TOTAL);
    hideErr();
    var el = stepEl(n);
    var lg = el ? el.querySelector('legend') : null;
    if (live && lg) live.textContent = 'السؤال ' + ar(n) + ' من ' + ar(TOTAL) + ': ' + lg.textContent.trim();
    if (focus !== false && lg) lg.focus();
    save();
  }

  function showErr(msg) {
    if (!errBox) return;
    errBox.textContent = msg;
    errBox.hidden = false;
  }
  function hideErr() {
    if (!errBox) return;
    errBox.textContent = '';
    errBox.hidden = true;
  }

  function num(name) {
    var el = q('[name="' + name + '"]');
    if (!el) return NaN;
    var v = parseFloat(String(el.value).replace(/[٠-٩]/g, function (d) { return String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)); }));
    return v;
  }

  function pick(name) {
    var el = q('[name="' + name + '"]:checked');
    return el ? el.value : '';
  }

  /* ================= التحقق ================= */

  function collect(n) {
    if (n === 1) { st.goal = pick('goal'); }
    if (n === 2) { st.sex = pick('sex'); st.age = num('age'); var c = q('[name="health"]'); st.health = !!(c && c.checked); }
    if (n === 3) { st.height = num('height'); st.weight = num('weight'); }
    if (n === 4) { st.act = pick('act'); }
    if (n === 5) { st.place = pick('place'); var f = q('[name="freq"]'); st.freq = f ? f.value : ''; }
    if (n === 6) { st.hurdle = pick('hurdle'); }
  }

  var badField = '';

  function bad(field, msg) { badField = field; return msg; }

  function validate(n) {
    badField = '';
    if (n === 1 && !st.goal) return bad('goal', 'اختار هدفك الأول عشان نكمّل.');
    if (n === 2) {
      if (!st.sex) return bad('sex', 'اختار النوع الأول.');
      if (!st.age || isNaN(st.age)) return bad('age', 'اكتب سنك بالسنة.');
      if (st.age < AGE_MIN || st.age > AGE_MAX) {
        return bad('age', 'اكتب سن صحيح بين ' + ar(AGE_MIN) + ' و' + ar(AGE_MAX) + ' سنة.');
      }
    }
    if (n === 3) {
      if (!st.height || isNaN(st.height) || st.height < H_MIN || st.height > H_MAX) {
        return bad('height', 'الطول لازم يكون بين ' + ar(H_MIN) + ' و' + ar(H_MAX) + ' سنتيمتر.');
      }
      if (!st.weight || isNaN(st.weight) || st.weight < W_MIN || st.weight > W_MAX) {
        return bad('weight', 'الوزن لازم يكون بين ' + ar(W_MIN) + ' و' + ar(W_MAX) + ' كيلوجرام.');
      }
    }
    if (n === 4 && !st.act) return bad('act', 'اختار مستوى نشاطك اليومي.');
    if (n === 5) {
      if (!st.place) return bad('place', 'قولنا بتتمرن فين.');
      if (st.place !== 'none' && !st.freq) return bad('freq', 'اختار بتتمرن كام مرة في الأسبوع.');
    }
    if (n === 6 && !st.hurdle) return bad('hurdle', 'اختار أكبر حاجة بتوقفك.');
    return '';
  }

  function focusField(name) {
    if (!name) return;
    var el = q('[name="' + name + '"]');
    if (el) el.focus();
  }

  /* استبعاد: سن أقل من ١٨ أو أكبر من ٦٥، أو حالة صحية / حمل / رضاعة */
  function isBlocked() {
    if (st.health) return true;
    var a = +st.age;
    return !!a && (a < AGE_OK_MIN || a > AGE_OK_MAX);
  }

  /* ================= الحسبة ================= */

  function compute() {
    var w = +st.weight, h = +st.height, a = +st.age;
    /* Mifflin-St Jeor */
    var bmr = 10 * w + 6.25 * h - 5 * a + (st.sex === 'male' ? 5 : -161);
    var tdee = bmr * (ACTIVITY[st.act] || 1.2);
    var target = tdee * (GOAL_ADJ[st.goal] || 1);

    var floor = CALORIE_FLOOR[st.sex === 'male' ? 'male' : 'female'];
    var raw = Math.round(target / 10) * 10;
    var calories = raw < floor ? floor : raw; /* القفل الصلب — بيتطبق دايمًا في الآخر */

    var protein = Math.round(w * (PROTEIN_PER_KG[st.goal] || 1.4) / 5) * 5;
    var water = Math.round(w * WATER_ML_PER_KG / 100) / 10; /* لتر برقم عشري واحد */

    /* المعدل الأسبوعي الآمن كنسبة من وزن الجسم.
       نزول: ٠٫٥٪ – ١٪. زيادة: ٠٫٢٥٪ – ٠٫٥٪ — الزيادة الأسرع من كده
       بتبقى دهون في أغلبها مش عضل، فمينفعش نستخدم نفس معدل النزول. */
    var rateLo = st.goal === 'bulk' ? 0.0025 : 0.005;
    var rateHi = st.goal === 'bulk' ? 0.005 : 0.01;
    var lo = Math.round(w * rateLo * 10) / 10;
    var hi = Math.round(w * rateHi * 10) / 10;

    return { calories: calories, protein: protein, water: water, lo: lo, hi: hi, floored: raw < floor };
  }

  function durationLine(r) {
    var rate = ar(r.lo.toFixed(1)) + '–' + ar(r.hi.toFixed(1)) + ' كجم في الأسبوع';
    if (st.goal === 'bulk') {
      return 'الزيادة الصحية بتيجي بالراحة: بمعدل آمن (٠٫٢٥٪ – ٠٫٥٪ من وزنك أسبوعيًا) يعني حوالي ' + rate + '، هتشوف فرق واضح خلال ٨–١٢ أسبوع من الالتزام. أسرع من كده بيبقى دهون مش عضل.';
    }
    if (st.goal === 'health') {
      return 'مفيش هدف وزن هنا — بالثبات على الأرقام دي هتحس بفرق في طاقتك ونومك خلال ٤–٦ أسابيع.';
    }
    return 'بمعدل آمن (٠٫٥٪ – ١٪ من وزنك أسبوعيًا) يعني حوالي ' + rate + '، هتشوف فرق واضح خلال ٨–١٢ أسبوع. مفيش أرقام سحرية أسرع من كده.';
  }

  /* ================= الملخص ================= */

  function summary(r) {
    var freq = st.place === 'none' ? 'لسه مبدأش' : (st.freq || '-') + ' مرات/أسبوع';
    return [
      'نتيجة كويز الهدف — زيرو فات',
      'الهدف: ' + (L.goal[st.goal] || '-'),
      'النوع: ' + (L.sex[st.sex] || '-') + ' | السن: ' + st.age,
      'الطول: ' + st.height + ' سم | الوزن: ' + st.weight + ' كجم',
      'النشاط: ' + (L.act[st.act] || '-'),
      'التمرين: ' + (L.place[st.place] || '-') + ' — ' + freq,
      'أكبر عائق: ' + (L.hurdle[st.hurdle] || '-'),
      '—',
      'السعرات: ' + r.calories + ' سعرة/يوم',
      'البروتين: ' + r.protein + ' جم/يوم',
      'المياه: ' + r.water.toFixed(1) + ' لتر/يوم'
    ].join('\n');
  }

  /* ================= شاشة النتيجة ================= */

  var lastResult = null;

  function showBlocked() {
    if (form) form.hidden = true;
    if (res) res.hidden = true;
    if (blocked) {
      blocked.hidden = false;
      var h = blocked.querySelector('h2');
      if (live && h) live.textContent = h.textContent.trim();
      if (h) h.focus();
    }
    if (fill) fill.style.width = '100%';
    emit({ step: st.step, goal: st.goal, phase: 'blocked' });
  }

  function setText(sel, txt) { var el = q(sel); if (el) el.textContent = txt; }

  function showResult(focus) {
    var r = compute();
    lastResult = r;
    st.done = true;
    save();

    if (form) form.hidden = true;
    if (blocked) blocked.hidden = true;
    if (fill) fill.style.width = '100%';
    if (count) count.textContent = ar(TOTAL) + ' / ' + ar(TOTAL);
    if (track) track.setAttribute('aria-valuenow', String(TOTAL));

    setText('[data-zq-goaltag]', 'هدفك: ' + (L.goal[st.goal] || ''));
    setText('[data-zq-lede]', 'حسبنا الأرقام دي على أساس هدفك ونشاطك اليومي — خد بيها كخط أساسي وابدأ.');
    setText('[data-zq-cal]', ar(r.calories));
    setText('[data-zq-pro]', ar(r.protein));
    setText('[data-zq-wat]', ar(r.water.toFixed(1)));
    setText('[data-zq-time]', durationLine(r));
    setText('[data-zq-tip]', HURDLE_TIP[st.hurdle] || '');

    var floorNote = q('[data-zq-floor]');
    if (floorNote) floorNote.hidden = !r.floored;

    /* إظهار مجموعة المنتجات المطابقة للهدف (كلها مترندرة من الليكويد) */
    var ids = [], cards = 0;
    qa('[data-pool]').forEach(function (pool) {
      var on = pool.getAttribute('data-pool') === st.goal;
      pool.hidden = !on;
      if (on) {
        cards = qa('.zq-p', pool).length;
        qa('[data-vid]', pool).forEach(function (c) {
          var v = c.getAttribute('data-vid');
          if (v) ids.push(+v);
        });
      }
    });
    if (picks) picks.hidden = cards === 0;
    if (addBtn) {
      addBtn.setAttribute('data-ids', ids.join(','));
      addBtn.hidden = ids.length === 0; /* كل المنتجات نافدة — نسيب زرار الشير بس */
      addBtn.textContent = addLabel + (ids.length ? ' (' + ar(ids.length) + ')' : '');
    }

    /* `[data-zq-bodyfield]` اتشال مع فورم الواتساب (١٢ أكتوبر ٢٠٢٦).
       ⚠️ `summary()` **لازمة لسه** — زرار «ابعت النتيجة على واتساب» بيستخدمها. */

    if (res) {
      res.hidden = false;
      var h = res.querySelector('h2');
      if (live && h) live.textContent = 'النتيجة جاهزة: ' + h.textContent.trim();
      if (focus !== false && h) h.focus();
    }
    emit({ step: TOTAL, goal: st.goal, phase: 'complete', calories: r.calories, protein: r.protein });
  }

  /* ================= استعادة المدخلات ================= */

  function check(name, val) {
    /* القيم جاية من localStorage — نتأكد إنها نضيفة قبل ما نبني بيها selector */
    if (!val || !/^[a-z0-9_]+$/i.test(val)) return;
    var el = q('[name="' + name + '"][value="' + val + '"]');
    if (el) el.checked = true;
  }
  function setVal(name, val) {
    if (val === '' || val === null || typeof val === 'undefined' || (typeof val === 'number' && isNaN(val))) return;
    var el = q('[name="' + name + '"]');
    if (el) el.value = val;
  }

  function restore() {
    check('goal', st.goal);
    check('sex', st.sex);
    setVal('age', st.age);
    var c = q('[name="health"]');
    if (c) c.checked = !!st.health;
    setVal('height', st.height);
    setVal('weight', st.weight);
    check('act', st.act);
    check('place', st.place);
    setVal('freq', st.freq);
    check('hurdle', st.hurdle);
    syncFreq();
  }

  /* إخفاء عدد المرات لو لسه مبدأش */
  function syncFreq() {
    var wrap = q('[data-zq-freq]');
    if (!wrap) return;
    var none = pick('place') === 'none';
    wrap.hidden = none;
    if (none) { var f = q('[name="freq"]'); if (f) f.value = ''; }
  }

  /* ================= الأحداث ================= */

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = st.step;
      collect(n);
      var msg = validate(n);
      if (msg) { showErr(msg); focusField(badField); return; }
      save();
      /* الاستبعاد بيتقرر أول ما نعرف السن والحالة الصحية — من غير ما نضيع وقت الزائر */
      if (n === 2 && isBlocked()) { showBlocked(); return; }
      if (n === TOTAL) {
        if (isBlocked()) { showBlocked(); return; }
        showResult(true);
        return;
      }
      showStep(n + 1, true);
    });

    form.addEventListener('change', function (e) {
      if (e.target.name === 'place') syncFreq();
      hideErr();
    });
    form.addEventListener('input', hideErr);
  }

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      if (st.step > 1) showStep(st.step - 1, true);
    });
  }

  var restartBtns = qa('[data-zq-restart]');
  restartBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      reset();
      qa('input[type="radio"],input[type="checkbox"]', form).forEach(function (i) { i.checked = false; });
      qa('input[type="number"]', form).forEach(function (i) { i.value = ''; });
      var f = q('[name="freq"]'); if (f) f.value = '';
      syncFreq();
      showStep(1, true);
    });
  });

  /* ---------- ضيف الباقة كلها للسلة ---------- */
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (addBtn.classList.contains('busy') || addBtn.disabled) return;
      var raw = (addBtn.getAttribute('data-ids') || '').split(',').filter(Boolean);
      if (!raw.length) return;
      if (addErr) addErr.hidden = true;
      addBtn.classList.add('busy');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: raw.map(function (id) { return { id: +id, quantity: 1 }; })
        })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var bubble = document.querySelector('[data-cart-count]');
          if (bubble) bubble.textContent = cart.item_count;
          emit({ step: TOTAL, goal: st.goal, phase: 'add_to_cart', items: raw.length });
          return window.ZFCartRefresh ? window.ZFCartRefresh() : null;
        })
        .then(function () {
          var opener = document.querySelector('[data-cart-open]');
          if (opener) opener.click();
        })
        .catch(function () {
          if (addErr) { addErr.textContent = 'حصلت مشكلة وإحنا بنضيف الباقة. جرّب تاني أو ضيف المنتجات واحد واحد.'; addErr.hidden = false; }
        })
        .then(function () { addBtn.classList.remove('busy'); });
    });
  }

  /* ---------- شير على واتساب ---------- */
  var shareBtn = q('[data-zq-share]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      if (!lastResult) return;
      var txt = ar(summary(lastResult)) + '\n' + window.location.href;
      window.open('https://wa.me/?text=' + encodeURIComponent(txt), '_blank', 'noopener');
    });
  }

  /* ================= البداية ================= */

  load();
  if (body) body.hidden = false;
  restore();

  if (st.done && st.goal && st.weight) {
    if (isBlocked()) showBlocked();
    else showResult(false);
    /* كان هنا سكرول لفورم «ابعتلي الخطة» بعد ما تتبعت (`contact_posted=true`).
       الفورم اتشال ١٢ أكتوبر ٢٠٢٦ فالسكرول مبقاش ليه لازمة. */
  } else {
    var start = st.step;
    if (!(start >= 1 && start <= TOTAL)) start = 1;
    showStep(start, false);
  }

  emit({ step: st.step, goal: st.goal, phase: 'start' });
})();
